import { Box, Button, Grid } from "@mui/material";
import Input from "components/atoms/Input";
import { useTranslation } from "react-i18next";

type PayfortPaymentFormProps = {
  val: {
    number: string;
    name: string;
    expiry: string;
    cvc: string;
    issuer: string;
  };
  errors: {
    number: string;
    name: string;
    expiry: string;
    cvc: string;
  };
  touched: {
    number: boolean;
    name: boolean;
    expiry: boolean;
    cvc: boolean;
  };
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onInputFocus: (e: React.FocusEvent<HTMLInputElement>) => void;
  onInputBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
};

export default function PayfortPaymentForm({
  val,
  errors,
  touched,
  onInputChange,
  onInputFocus,
  onInputBlur,
  onSubmit,
}: PayfortPaymentFormProps) {
  const { t } = useTranslation("translation");

  return (
    <Box>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Input
              type="tel"
              label={String(t("cardnumber", "Card number"))}
              name="number"
              className="form-control"
              placeholder={String(t("cardnumber", "Card number"))}
              required
              value={val.number}
              onChange={onInputChange}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
              error={touched.number && !!errors.number}
              helperText={touched.number && errors.number ? errors.number : ""}
            />
          </Grid>
          <Grid item xs={12}>
            <Input
              type="text"
              name="name"
              label={String(t("cardname", "Name on card"))}
              className="form-control"
              placeholder={String(t("cardname", "Name on card"))}
              required
              value={val.name}
              onChange={onInputChange}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
              error={touched.name && !!errors.name}
              helperText={touched.name && errors.name ? errors.name : ""}
            />
          </Grid>
          <Grid item xs={6}>
            <Input
              type="tel"
              name="expiry"
              label={String(t("expiry", "Expiry"))}
              className="form-control"
              placeholder={String(t("validthru", "MM/YY"))}
              required
              value={val.expiry}
              onChange={onInputChange}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
              error={touched.expiry && !!errors.expiry}
              helperText={touched.expiry && errors.expiry ? errors.expiry : ""}
            />
          </Grid>
          <Grid item xs={6}>
            <Input
              type="tel"
              name="cvc"
              label={String(t("cvc", "CVC"))}
              className="form-control"
              placeholder={String(t("cvc", "CVC"))}
              required
              value={val.cvc}
              onChange={onInputChange}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
              error={touched.cvc && !!errors.cvc}
              helperText={touched.cvc && errors.cvc ? errors.cvc : ""}
            />
          </Grid>
        </Grid>
        <input type="hidden" name="issuer" value={val.issuer} />
        <Button
          style={{ height: "52px", marginTop: "18px", borderRadius: "12px" }}
          fullWidth
          disableElevation
          variant="contained"
          color="info"
          type="submit"
        >
          {t("payNow")}
        </Button>
      </form>
      <div id="payment_form_div" style={{ display: "none" }} />
    </Box>
  );
}
